import $ from "jquery"
import "select2"

export function initSelect2() {
  document.querySelectorAll("select").forEach((el) => {
    if (!el.classList.contains("select2-hidden-accessible")) {
      const minResults =
        el.dataset.minimumResultsForSearch !== undefined
          ? parseInt(el.dataset.minimumResultsForSearch, 10)
          : 10
      $(el).select2({ minimumResultsForSearch: minResults })
    }
  })
}

document.addEventListener("DOMContentLoaded", () => initSelect2())
$(document).on("cocoon:after-insert", () => initSelect2())
